import { useDispatch } from "react-redux";
import {
  setSingleFile,
  setError,
  clearFiles,
  setProcessedFile,
} from "../index";

export const useSpedDevolutionActions = () => {
  const dispatch = useDispatch();

  const updateSingleFile = (file: File | null) => dispatch(setSingleFile(file));
  
  const updateError = (error: string | null) => dispatch(setError(error));
  const updateProcessedFile = (content: string | null) =>
    dispatch(setProcessedFile(content));
  const clearAllFiles = () => dispatch(clearFiles());
  return {
    updateSingleFile,
    updateError,
    updateProcessedFile,
    clearAllFiles,
  };
};
